// extracted by mini-css-extract-plugin
export default {"mainWrraper":"style_mainWrraper__ywE-Q","collapseWrraper":"style_collapseWrraper__Y8LpO","plusIcon":"style_plusIcon__LNGq8"};